
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import AlbumTagsPc from "./album-tags/album-tags-pc.vue";
import AlbumTagsPhone from "./album-tags/album-tags-phone.vue";
import { mapGetters } from "vuex";
import TagIdMap from "../../config/xct-tag-map.js";
import { XTAlbum } from "@/models";

export default {
data() {
return {
xm_icon_list: [
{
src: require("../../assets/xm/xm_jingxuan.png"),
name: "jingxuan",
text: "精选",
key: "virtual-recommend-id"
},
{
src: require("../../assets/xm/xm_shige.png"),
name: "shige",
text: "诗歌",
key: "5b1b429dfb4ffe0031345778"
},
{
src: require("../../assets/xm/xm_guoxue.png"),
name: "guoxue",
text: "国学",
key: "5b1b441f67f356003191f352"
},
{
src: require("../../assets/xm/xm_wenxue.png"),
name: "wenxue",
text: "文学",
key: "5b1b4424a22b9d0034acff35"
},
{
src: require("../../assets/xm/xm_jiaoyu.jpg"),
name: "jiaoyu",
text: "教育",
key: "5b1b46acd50eee0031e9af9d"
},
{
src: require("../../assets/xm/xm_yuwen.jpg"),
name: "yuwen",
text: "语文",
key: "5b1a62df9f5454003b06faba"
},
{
src: require("../../assets/xm/xm_ertong.png"),
name: "ertong",
text: "儿童",
key: "5b1b431d9f5454003d83356c"
},
{
src: require("../../assets/xm/xm_wenhua.jpg"),
name: "wenhua",
text: "文化",
key: "5b1b448e17d009005ba0272d"
},
{
src: require("../../assets/xm/xm_xiqu.png"),
name: "xiqu",
text: "戏曲",
key: "5b1dde5917d009003b14b61f"
},
{
src: require("../../assets/xm/xm_yinyue.jpg"),
name: "yinyue",
text: "音乐",
key: "5b1b42e0fe88c200367d108d"
},
{
src: require("../../assets/xm/xm_shenghuo.jpg"),
name: "shenghuo",
text: "生活",
key: "5b1b446ba22b9d0034ad012e"
},
{
src: require("../../assets/xm/xm_foxue.png"),
name: "foxue",
text: "佛学",
key: "5b1b45099f54540035fe9bd0"
}
],


tagId: null
};
},

computed: {
...mapGetters(["isPc"])
},

components: {
Swiper,
SwiperItem,
AlbumTagsPc,
AlbumTagsPhone
},

watch: {
"$route.params.tagId": {
handler(n, o) {
this.tagId = n;
},
immediate: true
}
},

methods: {
goToAlbumList(iconItem) {
let tagId = iconItem.key;

this.$router.push({
name: "xctAlbums",
params: {
tagId: iconItem.key
}
});
}
}
};



// WEBPACK FOOTER //
// ./src/components/xc_time/AlbumTags.vue